<template>
  <b-card header="Detil PPFTZ">
    <loading :active.sync="this.$store.state.barpin.isLoading" :is-full-page="false"></loading>
    <div class="pull-right">
      <b-button variant="secondary" v-b-modal.modal-catatan @click="getCatatan($store.state.barpin.header.id_aju)">
        Catatan <i class="fa fa-bars"></i>
      </b-button>
    </div>
    <h3>Header</h3>
    <div class="row">
      <div class="col-md-6 col-sm-6">
        <table class="table table-bordered">
          <tr v-for="(value, key) in this.$store.state.barpin.header">
            <template v-for="header in headers">
              <template v-if="key === header.value">
                <td width="30%" class="bold">{{ header.text}}</td>
                <td>
                  :
                  <template v-if="key === 'jns_aju'">
                    {{
                        value === '1' ? 'Barang Pindahan' : (value === '2' ? 'Kendaraan Bermotor' : '')
                    }}
                  </template>
                  <template v-else>{{ value}}</template>
                </td>
              </template>
            </template>
          </tr>
        </table>
      </div>
      <div class="col-md-6 col-sm-6">
        <table class="table table-bordered">
          <tr v-for="(value, key) in this.$store.state.barpin.header">
            <template v-for="header in headers2">
              <template v-if="key === header.value">
                <td width="30%" class="bold">{{ header.text}}</td>
                <td>: <template v-if="key === 'pel_muat'">
                    {{
                        value + ' - ' + $store.state.barpin.header.ref_pel_muat.NM_LOKASI
                    }}
                  </template>
                  <template v-if="key === 'pel_tujuan'">
                    {{
                        value + ' - ' + $store.state.barpin.header.ref_pel_tujuan.NM_LOKASI
                    }}
                  </template>
                  <template v-else>{{ value}}</template>
                </td>
              </template>
            </template>
          </tr>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-sm-6">
        <table class="table table-bordered">
          <tr v-for="(value, key) in this.$store.state.barpin.header">
            <template v-for="header in headers3">
              <template v-if="key === header.value">
                <td width="30%" class="bold">{{ header.text}}</td>
                <td>: {{ value}}</td>
              </template>
            </template>
          </tr>
        </table>
      </div>
      <div class="col-md-6 col-sm-6">
        <table class="table table-bordered">
          <tr v-for="(value, key) in this.$store.state.barpin.header">
            <template v-for="header in headers4">
              <template v-if="key === header.value">
                <td width="30%" class="bold">{{ header.text}}</td>
                <td>: {{ value}}</td>
              </template>
            </template>
          </tr>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-sm-6">
        <div>
          <h3>File Upload</h3>
          <ListFilePpftz />
        </div>
      </div>
      <div class="col-md-6 col-sm-6">
        <div v-if="$store.state.barpin.kontainer.length">
          <h3>Kontainer</h3>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Nomor Kontainer</th>
                <th>Ukuran/Jenis Kontainer</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in this.$store.state.barpin.kontainer">
                <td>{{ item.NO_KONTAINER}}</td>
                <td>{{ `${item.UKURAN_KONTAINER} / ${item.JNS_KONTAINER}`}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-if="$store.state.barpin.barang.length">
      <h3>Barang</h3>
      <table class="table table-striped table-responsive mt-3">
        <thead>
          <tr>
            <th class="text-left">Nama Barang</th>
            <th class="text-left">Jumlah Barang</th>
            <th class="text-left">Nilai Barang</th>
            <th>Nilai BM</th>
            <th>Nilai PPN</th>
            <th>Nilai Pph</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in this.$store.state.barpin.barang" :key="item.URAIAN_BARANG">
            <td>{{ item.URAIAN_BARANG}}</td>
            <td>{{ `${item.JML_SATUAN} ${item.JNS_SATUAN} / ${item.JML_KEMASAN} ${item.JNS_KEMASAN} `}}</td>
            <td>{{ item.CIF.toLocaleString()}}</td>
            <td>{{ item.NILAI_BM == null ? '' : item.NILAI_BM.toLocaleString()}}</td>
            <td>{{ item.NILAI_PPN == null ? '' : item.NILAI_PPN.toLocaleString()}}</td>
            <td>{{ item.NILAI_PPH == null ? '' : item.NILAI_PPH.toLocaleString()}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div slot="footer">
      <router-link to="/ppftz/browse">
        <b-button variant="secondary">
          <i class="fa fa-reply"></i> Kembali
        </b-button>
      </router-link>
    </div>
    <modal-catatan />
  </b-card>
</template>
<script>
import ListFilePpftz from './ListFilePpftz.vue'
import swal from 'sweetalert'
import ModalCatatan from '../modal/ModalCatatan.vue'
import {mapActions} from 'vuex'

export default {
  components: {
    ListFilePpftz,
    ModalCatatan
  },
  data () {
    return {
      headers: [
        {text: 'No. Pengajuan', value: 'no_aju'},
        // { text: 'Tgl. Pengajuan', value: 'tgl_aju' },
        {text: 'No. Daftar', value: 'no_daftar'},
        {text: 'Tgl. Daftar', value: 'tgl_daftar'},
        {text: 'Jenis Pengajuan', value: 'jns_aju'},
        {text: 'No. SPPB', value: 'no_sppb'},
        {text: 'Tgl. SPPB', value: 'tgl_sppb'}
      ],
      headers2: [
        {text: 'Moda Angkutan', value: 'moda_angkutan'},
        {text: 'Tempat Penimbunan', value: 'id_gudang'},
        {text: 'Pelabuhan Muat', value: 'pel_muat'},
        {text: 'Pelabuhan Tujuan', value: 'pel_tujuan'},
        {text: 'Bruto', value: 'bruto'},
        {text: 'Estimasi Tgl. Pengeluaran', value: 'tgl_pengeluaran'}
      ],
      headers3: [
        {text: 'Nama Pengirim', value: 'nama_kuasa'},
        {text: 'Jenis Identitas Pengirim', value: 'jns_identitas_kuasa'},
        {text: 'Nomor Identitas Pengirim', value: 'no_identitas_kuasa'},
        {text: 'Alamat Pengirim', value: 'alamat_kuasa'}
      ],
      headers4: [
        {text: 'Nama Penerima', value: 'nama'},
        {text: 'Jenis Identitas Penerima', value: 'jns_identitas'},
        {text: 'Nomor Identitas Penerima', value: 'no_identitas'},
        {text: 'Alamat Penerima', value: 'alamat'}
      ]
    }
  },
  created () {
    this.getData(this.$route.params.id).then(() => {
      if (this.$store.state.barpin.header.no_aju === undefined) {
        swal('error', 'error', 'error').then(() => {
          this.$router.push('/dashboard')
        })
      } else {
        this.getKontainer(this.$store.state.barpin.header.id_aju)
        this.getBarang(this.$store.state.barpin.header.id_aju)
      }
    })
  },
  methods: {
    ...mapActions({
      getData: 'barpin/getData',
      getKontainer: 'barpin/getKontainer',
      getBarang: 'barpin/getBarang',
      getCatatan: 'barpin/getCatatan'
    })
  }
}
</script>
<style scoped>
.bold {
  font-weight: 700;
}

table {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/ppftz/browse/DetilPpftz.vue?e591fc72